import React,{useEffect,useRef} from "react";
import NavBar from "../components/NavBar";
import WhiteCard from "../components/WhiteCard";
import Bar from "../components/Bar";
import Footer from "../components/Footer";
import SmoothScroll from "../components/Lenis";
import Pricing from "../components/Pricing";
import RedBanner from "../components/RedBanner";
import icon1 from "../assets/note.svg"
import icon2 from "../assets/Vector2.svg"
import icon3 from "../assets/Vector3.svg"
import icon4 from "../assets/Vector4.svg"
import icon5 from "../assets/Vector5.svg"
import icon6 from "../assets/Vector6.svg"
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);



const Services = ()=>{
  SmoothScroll()
    
    const Title = useRef(null);
    const sub = useRef(null);
    const s1 = useRef(null);
    const s2 = useRef(null);

    useEffect(() => {
        // Set initial states
        gsap.set(Title.current, { opacity: 0, y: 100 });
        gsap.set(sub.current, { opacity: 0, y: 100 });
        gsap.set(s1.current, { opacity: 0, y: 100 });
        gsap.set(s2.current, { opacity: 0, y: 100 });
      
        // Title Animation
        gsap.to(Title.current, {
          opacity: 1,
          y: 0,
          duration: 1,
          scrollTrigger: {
            trigger: Title.current,
            start: "top 80%",
            end: "bottom top",
            toggleActions: "play none none none",
          },
        });
      
        // Subtitle Animation
        gsap.to(sub.current, {
            opacity: 1,
            y: 0,
            duration: 1,
            scrollTrigger: {
              trigger: sub.current,
              start: "top 80%",
              end: "bottom top",
              toggleActions: "play none none none",
            },
          });
      
        // Service 1 Animation
        gsap.to(s1.current, {
            opacity: 1,
            y: 0,
            duration: 1,
            scrollTrigger: {
              trigger: s1.current,
              start: "top 80%",
              end: "bottom top",
              toggleActions: "play none none none",
            },
            });

        // Service 2 Animation
        gsap.to(s2.current, {
            opacity: 1,
            y: 0,
            duration: 1,
            scrollTrigger: {
              trigger: s2.current,
              start: "top 110%",
              end: "bottom top",
              toggleActions: "play none none none",
            },
            });
    },[]);

    return(
        <div className="bg-black">
        <NavBar />
        <section className="bg-whiteExtra pt-14 md:pt-24 font-guton">
    <div className="flex flex-col items-center pb-10 max-w-[1440px] mx-auto">
        <Bar />
        <h1 ref={Title} className="text-34 leading-32 w-90 md:text-46 xl:text-80 font-semibold text-center md:w-75 md:leading-36 xl:leading-70 mt-4 mb-2 xl:mb-3 xl:mt-4 md:mt-6 md:mb-2 tracking-[-3px]">Your Complete<br /> Study Abroad Partner
        </h1>
        <h2 ref={sub} className="text-12 leading-12 md:text-14 xl:text-24 md:leading-14 xl:leading-24 text-center w-90 md:w-70 tracking-[-0.6px]">
            Estudy takes care of all the worries you get from studying abroad. From securing university acceptance to guiding you through visas. <strong>We’re here to support you every step of the way.</strong>
        </h2>

        {/* Grid Container */}
        <div ref={s1} className="w-90 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-4 xl:gap-8 px-12 md:px-0 md:p-4 mt-8">
            {/* Cell 1 */}
            <div className="flex text-white space-x-4 md:space-x-4 xl:space-x-6">
                {/* Adjusted Red Background Div */}
                <div className="w-8 h-8 md:w-[36px] md:h-[32px] xl:w-10 xl:h-10 bg-custom-gradient rounded-md flex p-[1px]"><img src={icon1} alt="" className="w-90 mx-auto"/></div>
                <div className="flex-col w-90">
                    <h2 className="text-14 leading-14 md:text-14 md:leading-12 xl:text-24 xl:leading-24 font-medium text-black w-85 md:w-full xl:w-80 mb-2 md:mb-3 tracking-[-0.7px]">
                        University Applications & Acceptance
                    </h2>
                    <p className="text-8 leading-8 md:text-10 md:leading-10 xl:text-15 xl:leading-14 font-normal text-black">
                        Help you choose the best universities that fit your goals and preferences, and handle applications to ensure a 90% acceptance rate (when all documents are in order).
                    </p>
                </div>
            </div>

            {/* Cell 2 */}
            <div className="flex text-white space-x-4 md:space-x-4 xl:space-x-6">
                <div className="w-8 h-8 md:w-[36px] md:h-[32px] xl:w-10 xl:h-10 bg-custom-gradient rounded-md  flex p-[4px]"><img src={icon2} alt="" className="w-90 mx-auto"/></div>
                <div className="flex-col w-90">
                    <h2 className="text-14 leading-14 md:text-16 md:leading-12 xl:text-24 xl:leading-24 font-medium text-black md:w-full xl:w-80 mb-2 md:mb-3 tracking-[-0.7px]">
                        Visa Support
                    </h2>
                    <p className="text-10 leading-8 md:text-10 md:leading-10 xl:text-15 xl:leading-14 font-normal text-black">
                        Step-by-step guidance for completing paperwork and preparing for visa interviews. While also premium packages include in-depth consultation and mock interview prep.
                    </p>
                </div>
            </div>

            {/* Cell 3 */}
            <div className="flex text-white space-x-4 md:space-x-4 xl:space-x-6">
                <div className="w-8 h-8 md:w-[36px] md:h-[32px] xl:w-10 xl:h-10 bg-custom-gradient rounded-md flex p-[1px]"><img src={icon3} alt="" className="w-90 mx-auto"/></div>
                <div className="flex-col w-90">
                    <h2 className="text-14 leading-14 md:text-14 md:leading-12 xl:text-24 xl:leading-24 font-medium text-black md:w-full xl:w-80 mb-2 md:mb-3 tracking-[-0.7px]">
                        Accommodation Assistance
                    </h2>
                    <p className="text-8 leading-8 md:text-10 md:leading-10 xl:text-15 xl:leading-14 font-normal text-black">
                        Support in finding university housing or private accommodation based on your preferences.
                    </p>
                </div>
            </div>

            {/* Cell 4 */}
            <div className="flex text-white space-x-4 md:space-x-4 xl:space-x-6">
                <div className="w-8 h-8 md:w-[36px] md:h-[32px] xl:w-10 xl:h-10 bg-custom-gradient rounded-md flex p-[1px]"><img src={icon4} alt="" className="w-90 mx-auto"/></div>
                <div className="flex-col w-90">
                    <h2 className="text-14 leading-14 md:text-14 md:leading-12 xl:text-24 xl:leading-24 font-medium text-black md:w-full xl:w-80 mb-2 md:mb-3 tracking-[-0.7px]">
                        Personalized Consultation
                    </h2>
                    <p className="text-8 leading-8 md:text-10 md:leading-10 xl:text-15 xl:leading-14 font-normal text-black">
                        Provide in-depth insights into studying and living abroad, tailored to your needs. Making sure we explore the cities, courses, and opportunities available.
                    </p>
                </div>
            </div>

            {/* Cell 5 */}
            <div className="flex text-white space-x-4 md:space-x-4 xl:space-x-6">
                <div className="w-8 h-8 md:w-[36px] md:h-[32px] xl:w-10 xl:h-10 bg-custom-gradient rounded-md flex p-[1px]"><img src={icon5} alt="" className="w-90 mx-auto"/></div>
                <div className="flex-col w-90">
                    <h2 className="text-14 leading-14 md:text-14 md:leading-12 xl:text-24 xl:leading-24 font-medium text-black md:w-full xl:w-80 mb-2 md:mb-3 tracking-[-0.7px]">
                        Work and Post-University Guidance
                    </h2>
                    <p className="text-8 leading-8 md:text-10 md:leading-10 xl:text-15 xl:leading-14 font-normal text-black">
                        Advice on finding part-time work during your studies. Insights into opportunities available after graduation.
                    </p>
                </div>
            </div>

            {/* Cell 6 */}
            <div className="flex text-white space-x-4 md:space-x-4 xl:space-x-6">
                <div className="w-8 h-8 md:w-[36px] md:h-[32px] xl:w-10 xl:h-10 bg-custom-gradient rounded-md flex p-[1px]"><img src={icon6} alt="" className="w-90 mx-auto"/></div>
                <div className="flex-col w-90">
                    <h2 className="text-14 leading-14 md:text-14 md:leading-12 xl:text-24 xl:leading-24 font-medium text-black md:w-full xl:w-80 mb-2 md:mb-3 tracking-[-0.7px]">
                        Document Preparation
                    </h2>
                    <p className="text-8 leading-8 md:text-10 md:leading-10 xl:text-15 xl:leading-14 font-normal text-black">
                        Ensure all paperwork is accurate and ready for submission, and providing a detailed checklist to keep you organized.
                    </p>
                </div>
            </div>
        </div>

        {/* Buttons */}
        <div ref={s2} className="flex w-content space-x-4 text-14 md:text-14 xl:text-24 mt-8 mb-0 md:my-16">    
            <a href="https://wa.link/eaoxxu" target="_blank" rel="noopener noreferrer" className="flex font-guton font-bold bg-custom-gradient text-white px-6 md:px-8 xl:px-14 rounded-full md:py-1 xl:py-3 leading-30 hover:text-white hover:bg-custom-hover-gradient transition duration-500 ease-in-out">
                Apply Now
            </a>
            <a href="#Pricing" className="flex font-guton font-bold border-[1.5px] border-grey text-black px-8 md:px-6 xl:px-10 rounded-full md:py-1 xl:py-3 leading-30 hover:text-white hover:bg-custom-hover-gradient transition duration-500 ease-in-out">
                Pricing
            </a>
        </div>
    </div>
</section>
        {/* Whitecard */}
        <section className="w-90 mx-auto py-20">
        <WhiteCard />
        </section>
        <Pricing />
        <RedBanner />
        <Footer />
        </div>
    )
}

export default Services;